/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_Context_Below_FloorInputs */



/**
* | output |
* | --- |
* | "The context window is below 128,000 tokens, the minimum oneAI accepts." |
*
* @param {Private_Models_Hint_Context_Below_FloorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_context_below_floor = /** @type {((inputs?: Private_Models_Hint_Context_Below_FloorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_Context_Below_FloorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Kontextfenster liegt unter 128.000 Tokens, dem Minimum für oneAI.")
	return /** @type {LocalizedString} */ ("The context window is below 128,000 tokens, the minimum oneAI accepts.")
});